import './styles.css'

import { createRoot } from 'react-dom/client'

import { LandingPage } from './LandingPage'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

createRoot(rootEl).render(<LandingPage />)
